import styled from 'styled-components';

import { Disease } from '@dreryk/medical-dictionaries-api';

import { StyledFlex } from '@dreryk/react-components';

import { MedicalDevicesPanelLoader } from './MedicalDevicesPanel.loader';
import { MedicalDevicesPanelHeader } from './MedicalDevicesPanelHeader';
import { MedicalDevicesPanelTabs } from './MedicalDevicesPanelTabs';

type MedicalDevicesPanelProps = {
   readonly patientId: number;
   readonly patientAge: number;
   readonly visitId: number;
   readonly visitDisease?: Disease;
};

const StyledMedicalDevicePanel = styled(StyledFlex)`
   height: 100%;
   width: 100%;
   overflow: auto;
`;
StyledMedicalDevicePanel.displayName = 'StyledMedicalDevicePanel';

export const MedicalDevicesPanel = (props: MedicalDevicesPanelProps): JSX.Element => {
   return (
      <StyledMedicalDevicePanel direction={'column'} gap={'12px'}>
         <MedicalDevicesPanelHeader />
         <MedicalDevicesPanelLoader visitId={props.visitId}>
            {({ existingOrder, refetch }) => (
               <MedicalDevicesPanelTabs
                  visitId={props.visitId}
                  patientId={props.patientId}
                  patientAge={props.patientAge}
                  visitDisease={props.visitDisease}
                  existingOrder={existingOrder}
                  refetchOrder={refetch}
               />
            )}
         </MedicalDevicesPanelLoader>
      </StyledMedicalDevicePanel>
   );
};
